import { createFileRoute } from '@tanstack/react-router'

import { BinMccFeeReportScreen } from './-components/bin-mcc-fee-report-screen.tsx'

export const Route = createFileRoute('/payments/bin-mcc-fee-report')({
  component: BinMccFeeReportScreen
})
